module.exports = __webpack_public_path__ + "img/UAV_data-2.f7b53013.jpg";